import { useNavigate, useLocation, Link } from "react-router-dom";
import { CoorporateType, Role } from "../constants/enum";
import { useGlobalState } from "../services/context/AuthContext";
import { capitalizeFirstLetter } from "../constants/helper";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useEffect, useState } from "react";
import { UtilService } from "../services/shared/UtilService";
import { msgTypes } from "../constants/msgTypes";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import WalletOutlinedIcon from "@mui/icons-material/WalletOutlined";
export default function Header() {
  const { userInfo, setUserInfo } = useGlobalState();
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  const [canGoBack, setCanGoBack] = useState(false);

  const HIDE_BACK_BUTTON_ROUTES = [
    "/flightbookingconfirmation",
    "/dashboard",
    "/hotelroomdetail",
  ]; // Add more paths if needed

  const SHOW_LOGO_BUTTON_ROUTES = [
    "/flightlist",
    "/flightDetail",
    "/hotelroomdetail",
    "/hotellist",
  ]; // Add more paths if needed

  useEffect(() => {
    const shouldShowBack =
      window.history.length > 1 &&
      !HIDE_BACK_BUTTON_ROUTES.includes(location.pathname);
    setCanGoBack(shouldShowBack);
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/");
  };

  useEffect(() => {
    fetchBalance();
  }, []);

  const fetchBalance = async () => {
    try {
      const response = await UtilService.fetchBalance();
      if (response?.statusMsg === msgTypes?.SUCCESS?.msg) {
        // Assuming the response contains the balance data
        setUserInfo({
          ...userInfo,
          postpaidBalance: response.data?.postpaid || 0,
          prepaidBalance: response.data?.prepaid || 0,
        });
      } else {
        console.error("Failed to fetch balance data");
      }
    } catch (error) {}
  };

  const currency = userInfo?.currencyCode || "AED";
  return (
    <div className="flex grow">
      <div className="mb-4">
        <header
          className="header fixed top-0 z-10 start-0 end-0 flex items-stretch shrink-0 bg-[--tw-page-bg] dark:bg-[--tw-page-bg-dark]"
          id="header"
        >
          <div
            className={`flex items-stretch ${
              canGoBack &&
              ![
                "/flightlist",
                "/flightDetail",
                "/hotellist",
                "/hotelroomdetail",
              ].includes(location.pathname)
                ? "header-left"
                : ""
            }`}
            id="mega_menu_container"
          >
            <div className="ms-1 flex items-stretch">
              <div
                className="hidden lg:flex lg:items-stretch"
                id="mega_menu_wrapper"
              >
                <div
                  className="menu flex-col lg:flex-row gap-5 lg:gap-7.5"
                  id="mega_menu"
                >
                  {/* Show ETWS logo only on specific routes */}
                  {SHOW_LOGO_BUTTON_ROUTES.includes(location.pathname) && (
                    <div className="menu-item active">
                      <Link
                        className="menu-link text-nowrap text-sm text-gray-800 font-medium"
                        to="/dashboard"
                      >
                        <span className="menu-title text-nowrap ms-5">
                          <img
                            src="media/images/EWTSLogo94_55.png"
                            alt="Logo"
                          />
                        </span>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className="container-fluid flex justify-between items-stretch"
            id="header_container"
          >
            {/* Mobile-logo */}
            <div className="flex gap-1 lg:hidden items-center -ms-1">
              <div className="flex items-center">
                <button
                  className="btn btn-icon btn-light btn-clear btn-sm"
                  data-drawer-toggle="#sidebar"
                >
                  <MenuIcon />
                </button>
              </div>
            </div>

            <div className="flex items-center gap-1.25 mt-3  text-xs lg:text-sm font-medium mb-2.5 lg:mb-0 d-xl-block d-none">
              {canGoBack && (
                <button
                  onClick={() => navigate(-1)}
                  className={`btn btn-light rounded-circle d-flex align-items-center justify-content-center me-2 ${
                    canGoBack &&
                    !["/flightlist", "/flightDetail", "/hotellist"].includes(
                      location.pathname
                    )
                      ? "header-back-button"
                      : "back-margin"
                  }`}
                >
                  <KeyboardBackspaceIcon titleAccess="Back" />
                </button>
              )}
            </div>

            <div className=" flex items-center gap-md-4 lg:gap-3.5 me-md-4 gap-2">
              {(userInfo?.roleName === Role.ADMIN ||
                userInfo?.roleName === Role.CORPORATE_USER) && (
                <>
                  <div
                    className="dropdown"
                    onMouseEnter={() => setShow(true)}
                    onMouseLeave={() => setShow(false)}
                  >
                    {/* Wallet Icon */}
                    <button
                      className="btn btn-light d-flex align-items-cent7er gap-0"
                      style={{
                        border: "none",
                        outline: "none",
                        boxShadow: "none",
                        margin: "-9px",
                      }}
                      type="button"
                      onClick={() => setShow(!show)}
                    >
                      {/* <AccountBalanceWalletOutlinedIcon className="text-muted fs-5 me-1" /> */}

                      <span className="fw-bold wallet-font usr-name">
                        <WalletOutlinedIcon className="me-1" />
                        Wallet <ArrowDropDownIcon className="pb-1" />
                      </span>
                    </button>

                    {/* Dropdown Menu */}
                    <ul
                      className={`dropdown-menu ${show ? "show" : ""}`}
                      style={{
                        minWidth: "auto",
                        position: "absolute",
                        top: "100%", // 👈 ensures below button
                        left: 0,
                        fontSize: "0.875rem", // 👈 small font size (14px approx)
                      }}
                    >
                      <li className="dropdown-item d-flex justify-content-between">
                        <span>
                          <AccountBalanceWalletOutlinedIcon className="text-muted fs-5 me-1" />
                          Prepaid:
                        </span>
                        <span className="fw-bold ms-2">
                          {currency} {userInfo?.prepaidBalance ?? 0}
                        </span>
                      </li>
                      <li className="dropdown-item d-flex justify-content-between">
                        <span>
                          <CreditCardOutlinedIcon className="text-muted fs-5 me-1" />
                          Postpaid:
                        </span>
                        <span className="fw-bold ms-2">
                          {currency} {userInfo?.postpaidBalance ?? 0}
                        </span>
                      </li>
                    </ul>
                  </div>
                </>
              )}

              <div className="menu">
                <span>
                  <i className="fa-regular fa-user px-1"></i>
                </span>
                <div className="menu-item menu-item-dropdown">
                  <span className="fw-bold usr-name">
                    {capitalizeFirstLetter(userInfo?.firstName ?? "") +
                      " " +
                      capitalizeFirstLetter(userInfo?.lastName ?? "")}
                  </span>
                </div>
              </div>

              <div className="menu" onClick={handleLogout}>
                <div className="menu-item menu-item-dropdown">
                  <button className="flex items-center gap-2 text-gray-700 hover:text-white font-medium py-1 px-2 rounded-md bg-white hover:bg-blue-600 border border-gray-300 shadow-sm transition-all duration-200">
                    <i className="fa-solid fa-power-off"></i> Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}
